import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'valutazione_8', 
  templateUrl: 'valutazione_8.html',
}) 

export class Valutazione_8Component{ 

  @Input('domanda') domanda: any; 
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output:any;
  risp: any;
  risposte_conferma = [];
  showconferma:boolean = true;
  showconferma_first:boolean = true;
  feed = '';
  showfeed:boolean = false;
  showfeed_first:boolean = false;
  first_aperta:boolean = false;
  risp_aperta:any;
  showesperto:boolean = false;
  seconda_domanda:boolean = false;
  risp_aperta_seconda:any;
  num_tentativi = 0;
  first_risposta:boolean = false;
  esperto_consiglia = '<div><img src="assets/icon/hat_gray.svg" class="tart_"><div text-center><b>PROSPETTIVA DELL’ESPERTO</b></div></div>';
  constructor(public events: Events,public translate: TranslateService) {
    this.output = 'test string';
    this.translate.get('domande.PROSPETTIVADELLESPERTO').subscribe(v => {
      this.esperto_consiglia = '<div><img src="assets/icon/hat_gray.svg" class="tart_"><div text-center><b>'+v+'</b></div></div>'; 
    })
    
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    /*for(let i=0;i<this.mq.listTentativi;i++){
      if(this.mq.listTentativi[i] == 'n')
        this.num_tentativi = i;
    }*/
    // for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
    //   let r = this.domanda['RispostaMicroStepList'][i];
    //   var hradio = document.getElementById('item_' + r.id).clientHeight;
    //   var radio_icon = document.getElementById(r.id).children[0];
    //   radio_icon.setAttribute("style", "height:" + hradio + "px !important");
    //   // radio_icon.children[0].setAttribute("style", "height:" + (hradio - 22) + "px !important");
    //   radio_icon.children[0].setAttribute("style", "height:" + (hradio - 10) + "px !important");
    // }
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.events.publish('start_tempo', this.domanda);
    this.num_tentativi = this.domanda.indiceFiglioDaMostrare;
    if(this.domanda.indiceFiglioDaMostrare == 0)
      this.first_aperta = true;
    else
      this.first_risposta = true;

  }
  prosegui(){
    //this.events.publish('valutazione', this.domanda, [this.risp_aperta,this.risp_aperta_seconda,this.risposte_conferma]);
    if(this.domanda['arrDomande'][this.num_tentativi]['TipologiaMicroStep_id'] == '9')
      this.events.publish('valutazione',this.domanda['arrDomande'][this.num_tentativi],this.risposte_conferma);
    else
      this.events.publish('valutazione',this.domanda['arrDomande'][this.num_tentativi],[this.risp_aperta_seconda]);
    
  }
  conferma_first(){
    this.showfeed_first = true;
    this.showconferma_first = false;
    
  }
  prosegui_risposta(){
    this.first_aperta = false;
    this.first_risposta = false;
    this.showesperto = true;
    this.events.publish('stop_tempo_parziale', this.domanda);
    this.events.publish('stop_tempo', this.domanda);
    //this.events.publish('valutazione_first', this.domanda, [this.risp_aperta]);
  }
  prosegui_first(){
    //mostra domanda di rating
    this.first_aperta = false;
    this.first_risposta = false;
    this.showesperto = true;
    this.events.publish('stop_tempo_parziale', this.domanda);
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('valutazione_first', this.domanda, [this.risp_aperta]);
  }
  prosegui_seconda(){
    this.first_aperta = false;
    this.showesperto = false;
    this.seconda_domanda = true;
    
  }
  conferma(){
    this.showfeed = true;
    this.showconferma = false;
    
  }
  sel(r) {
    let ris = [];
    ris[0] = r.id;
    //this.update_output(ris);
    this.risposte_conferma = ris;
  }


  resize() {
    var x = document.getElementById("valutazione_"+this.domanda.id);
    var element = x.children[0];
    var scrollHeight = element.scrollHeight;
    element.setAttribute('style','height:'+scrollHeight + 'px');
    x.style.height = (scrollHeight + 28) + 'px';
  }
  resize_() {
    var x = document.getElementById("valutazionex_"+this.domanda.id);
    var element = x.children[0];
    var scrollHeight = element.scrollHeight;
    element.setAttribute('style','height:'+scrollHeight + 'px');
    x.style.height = (scrollHeight + 28) + 'px';
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/valutazione_8.ts